import React, { useContext, useState } from 'react';
import { adminUserPut } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import Modal from '../UI/Modal';
import { somethingWentWrongNotice, successUserChangeNotice, usernameExistingsNotice } from '../UI/Notifications';
import { useForm } from 'react-hook-form';
import ChangeUsernameModalContent from '../ModalContents/ChangeUsernameModalContent';
import { SearchContext } from '../../context/Search';

const ChangeUserName = ({ id }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const history = useHistory();
  const { setLoading, setSearchTrigger, searchTrigger } = useContext(SearchContext);
  const [show, setShow] = useState(false);
  const { register, handleSubmit, errors } = useForm();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Change Username");
    }

    setLoading(false);
  }

  const onSubmit = data => {
    setLoading(true);
    adminUserPut({username: data.username}, {user_id: id})
      .then(() => {
        handleClose();
        setSearchTrigger(!searchTrigger);
        setLoading(false);
        successUserChangeNotice("Change Username");
      })
      .catch(error => {
        if (error.response.status === 409) {
          usernameExistingsNotice();
          setLoading(false);
        } else {
          handleDefaultStatusCodes(error.response.status);
        }
        
        handleClose();
      });
  }

  const resetUserPassword = () => {
    handleShow();
  }

  return (
    <>
      <div
        onClick={() => resetUserPassword()}
        className="Dropdown_Item"
      >
        <span className="ml-2">Change Username</span>
      </div>
      <Modal 
        handleClose={handleClose} 
        show={show}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        buttonLabel="Change"
      >
        <ChangeUsernameModalContent 
          register={register}
          errors={errors}
        />
      </Modal>
    </>
  )
}

export default ChangeUserName;
